module.exports = __webpack_public_path__ + "../resources/img/bg_error02.2d53bc14.png";